import React from 'react';
import '@veneer/skeleton-loading';

const SkeletonLoading: React.FC = () => {
  return (
    <veneer-skeleton
      alignment="start"
      effect="wave"
      shape="pill"
    >
      <veneer-skeleton-shape
        shape="rectangle"
        height="28px"
        width="180px"
      />
    </veneer-skeleton>
  );
};

export default SkeletonLoading;
